/**
 * 功能使用统计左侧导航
 * 2019-6-17
 * Bai.Zhiming
 */
angular.module("featureUsageStatisticsLeftModule", []).
directive("featureUsageStatisticsLeft", ['$state', '$timeout', function($state, $timeout) {
    return {
        restrict: "E",
        replace: true,
        scope: {
            tenantList: '='
        },
        templateUrl: "./manageConfig/logManageMent/featureUsageStatistics/left/left_tpl.html",
        link: function(scope, $element, $attrs) {
            initStatus();
            initData();
            /**
             * [allTenant description] 选中“所有租户”
             * @return {[type]} [description]
             */
            scope.allTenant = function() {
                scope.status.selectedTenantId = "";
                $state.go('manageconfig.logmanage.featureusagestatistics', { tenantid: "" }, { reload: 'manageconfig.logmanage.featureusagestatistics' });
            };
            /**
             * [selectTenant description] 选择租户
             * @param  {[type]} item [description] 被选中的租户信息
             * @return {[type]}      [description]
             */
            scope.selectTenant = function(item) {
                scope.status.selectedTenantId = item.tenantid;
                $state.go('manageconfig.logmanage.featureusagestatistics', { tenantid: item.tenantid }, { reload: 'manageconfig.logmanage.featureusagestatistics' });
            }
            /**
             * [autoLocation description] 自动定位
             * @return {[type]} [description]
             */
            function autoLocation() {
                let routerArray = $state.current.name.split(".");
                if ($state.current.name.indexOf("manageconfig.logmanage.featureusagestatistics") < 0) {
                    $timeout(() => {
                        $element.find(".leveTitle")[0].click();
                    });
                } else {
                    scope.status.selectedTenantId = $state.params.tenantid;
                }
            }
            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                scope.status = {};
                scope.data = {};
                autoLocation();
            }
            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {}
        }
    }
}]);